export const SPLASH_DATA_GA = {
  VIEW: 'splash_view',
  CLOSE: 'splash_close',
  SKIPPED: 'splash_skipped',
  ENTER_CLICK: 'splash_enter_click',
  CTA_CLICK: 'splash_cta_click',
  DONT_SHOW_AGAIN_CHECKED: 'dont_show_again_checked',
  DONT_SHOW_AGAIN_UNCHECKED: 'dont_show_again_unchecked',
} as const;

export const SPLASH_DATA_TEST = {
  splash: 'splash',
  wrapper: 'splash-wrapper',
  image: 'splash-image',
  imageWrapper: 'splash-image-wrapper',
  headline: 'splash-headline',
  content: 'splash-content',
  buttonWrapper: 'splash-button-wrapper',
  homeButton: 'splash-home-button',
  ctaButton: 'splash-cta-button',
  checkbox: 'splash-checkbox',
} as const;
